module.exports = __webpack_public_path__ + "img/emojiOn.a904292.svg";